export default __webpack_public_path__ + "static/media/img-ln-8-govato.9c59869a.png";